module.exports = __webpack_public_path__ + "media/boostt_desktop.eed0c7bd.mp4";